import {createStore, compose, applyMiddleware} from 'redux';
import persistState from 'redux-sessionstorage'

import promise from 'redux-promise';
import thunk from 'redux-thunk';

import reducer from './reducers';

const composeEnhancers =
  typeof window === 'object' &&
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({}) : compose;

const enhancer = composeEnhancers(
  applyMiddleware(thunk, promise),
  persistState(['params', 'productData', 'touchedAttributes']),
);

const store = createStore(reducer, {
  previewLoading: false,
  productData: false,
  touchedAttributes: [],
  infoNoticeWasShown: false
}, enhancer);

export default store;
